/* PowerSound — interacciones (vanilla, sin librerías) */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    var els = document.querySelectorAll('.ps-reveal:not(.ps-visible)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('ps-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('ps-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function initCountUp() {
    var els = document.querySelectorAll('[data-ps-count]:not([data-ps-done])');
    if (!els.length) return;
    var run = function (el) {
      el.setAttribute('data-ps-done', '1');
      var target = parseFloat(el.getAttribute('data-ps-count')) || 0;
      if (reduce) { el.textContent = target; return; }
      var start = null, dur = 1400;
      var step = function (t) {
        if (!start) start = t;
        var p = Math.min((t - start) / dur, 1);
        el.textContent = Math.round(target * (1 - Math.pow(1 - p, 3)));
        if (p < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    };
    if (!('IntersectionObserver' in window)) { els.forEach(run); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { run(e.target); io.unobserve(e.target); } });
    }, { threshold: 0.4 });
    els.forEach(function (el) { io.observe(el); });
  }

  function initParallax() {
    var media = document.querySelectorAll('[data-ps-parallax]');
    if (!media.length || reduce) return;
    var ticking = false;
    var update = function () {
      media.forEach(function (m) {
        var k = parseFloat(m.getAttribute('data-ps-parallax')) || 0;
        var r = m.parentElement.getBoundingClientRect();
        if (r.bottom < 0 || r.top > window.innerHeight) return;
        m.style.transform = 'translate3d(0,' + (-r.top * k / 100) + 'px,0)';
      });
      ticking = false;
    };
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  function initColors() {
    document.querySelectorAll('[data-ps-colors]').forEach(function (root) {
      if (root.dataset.psReady) return;
      root.dataset.psReady = '1';
      var imgs = root.querySelectorAll('.ps-colors__stage img');
      var sws = root.querySelectorAll('.ps-swatch');
      var name = root.querySelector('[data-ps-color-name]');
      var link = root.querySelector('[data-ps-color-link]');
      sws.forEach(function (sw, i) {
        sw.addEventListener('click', function () {
          sws.forEach(function (s) { s.classList.remove('is-active'); s.setAttribute('aria-pressed', 'false'); });
          imgs.forEach(function (im) { im.classList.remove('is-active'); });
          sw.classList.add('is-active');
          sw.setAttribute('aria-pressed', 'true');
          if (imgs[i]) imgs[i].classList.add('is-active');
          if (name) name.textContent = sw.getAttribute('data-name');
          if (link && sw.getAttribute('data-url')) link.setAttribute('href', sw.getAttribute('data-url'));
        });
      });
    });
  }

  function money(cents, format) {
    var v = (cents / 100).toFixed(2);
    var parts = v.split('.');
    var withComma = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    // Quitar etiquetas HTML que algunas apps de moneda añaden al formato (p. ej. <span class=money>)
    format = (format || '${{amount}}').replace(/<[^>]*>/g, '');
    return format.replace(/\{\{\s*amount\s*\}\}/, withComma)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0])
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, parts[0] + ',' + parts[1]);
  }

  function initProduct() {
    document.querySelectorAll('[data-ps-product]').forEach(function (root) {
      if (root.dataset.psReady) return;
      root.dataset.psReady = '1';
      var dataEl = root.querySelector('[data-ps-variants]');
      var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
      var fmt = root.getAttribute('data-money-format');
      var idInput = root.querySelector('input[name="id"]');
      var priceEl = root.querySelector('[data-ps-price]');
      var compareEl = root.querySelector('[data-ps-compare]');
      var saveEl = root.querySelector('[data-ps-save]');
      var btn = root.querySelector('[data-ps-add]');
      var btnLabel = btn ? btn.querySelector('span') : null;
      var txtAdd = root.getAttribute('data-txt-add');
      var txtSold = root.getAttribute('data-txt-sold');
      var thumbs = root.querySelectorAll('.ps-thumb');
      var stickyPrice = document.querySelector('[data-ps-sticky-price]');

      var slides = root.querySelectorAll('.ps-gallery__slide');
      root.querySelectorAll('.ps-gallery__slide video').forEach(function (vd) { vd.setAttribute('playsinline', ''); vd.muted = true; });
      function showMedia(id) {
        slides.forEach(function (sl) {
          var on = sl.getAttribute('data-media-id') === String(id);
          sl.classList.toggle('is-active', on);
          var vd = sl.querySelector('video');
          if (vd) { if (on) { var p = vd.play(); if (p && p.catch) p.catch(function () {}); } else { vd.pause(); } }
          var ifr = sl.querySelector('iframe');
          if (ifr && !on) { var src = ifr.src; ifr.src = src; }
        });
      }
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          thumbs.forEach(function (x) { x.classList.remove('is-active'); });
          t.classList.add('is-active');
          showMedia(t.getAttribute('data-media-id'));
        });
      });
      var first = root.querySelector('.ps-gallery__slide.is-active video');
      if (first) { var p0 = first.play(); if (p0 && p0.catch) p0.catch(function () {}); }

      function current() {
        var sel = [];
        root.querySelectorAll('[data-ps-option]').forEach(function (fs) {
          var c = fs.querySelector('input:checked');
          sel.push(c ? c.value : null);
          var lbl = fs.querySelector('[data-ps-option-value]');
          if (lbl && c) lbl.textContent = c.value;
        });
        return variants.find(function (v) {
          return v.options.every(function (o, i) { return o === sel[i]; });
        });
      }
      function update() {
        var v = current();
        if (!v) {
          if (btn) { btn.disabled = true; if (btnLabel) btnLabel.textContent = txtSold; }
          return;
        }
        if (idInput) idInput.value = v.id;
        if (priceEl) priceEl.textContent = money(v.price, fmt);
        if (stickyPrice) stickyPrice.textContent = money(v.price, fmt);
        var hasCompare = v.compare_at_price && v.compare_at_price > v.price;
        if (compareEl) { compareEl.textContent = hasCompare ? money(v.compare_at_price, fmt) : ''; compareEl.hidden = !hasCompare; }
        if (saveEl) {
          saveEl.hidden = !hasCompare;
          if (hasCompare) saveEl.textContent = saveEl.getAttribute('data-tpl').replace('[x]', Math.round((1 - v.price / v.compare_at_price) * 100));
        }
        if (btn) { btn.disabled = !v.available; if (btnLabel) btnLabel.textContent = v.available ? txtAdd : txtSold; }
        var stockEl = root.querySelector('[data-ps-stock]');
        var stockMapEl = root.querySelector('[data-ps-stock-map]');
        if (stockEl && stockMapEl) {
          var stockMap = {};
          try { stockMap = JSON.parse(stockMapEl.textContent); } catch (e) {}
          var qty = stockMap[String(v.id)];
          var limit = parseInt(stockEl.getAttribute('data-threshold'), 10) || 10;
          var showStock = typeof qty === 'number' && qty > 0 && qty <= limit;
          stockEl.hidden = !showStock;
          if (showStock) {
            stockEl.querySelector('[data-ps-stock-text]').textContent = qty === 1
              ? stockEl.getAttribute('data-tpl-one')
              : stockEl.getAttribute('data-tpl').replace('[x]', qty);
          }
        }
        if (v.featured_media) {
          var th = root.querySelector('.ps-thumb[data-media-id="' + v.featured_media.id + '"]');
          if (th) th.click();
        }
        if (window.history && window.history.replaceState && root.hasAttribute('data-update-url')) {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', u.toString());
        }
      }
      root.querySelectorAll('[data-ps-option] input').forEach(function (inp) { inp.addEventListener('change', update); });

      // Color de cada parlante según la oferta elegida (Lleva 2, Lleva 3...)
      var unitBox = root.querySelector('[data-ps-unitcolors]');
      function syncUnits() {
        if (!unitBox) return;
        var bundleChecked = root.querySelector('.ps-bundle input:checked');
        var n = bundleChecked ? (parseInt(bundleChecked.value, 10) || 1) : 1;
        unitBox.hidden = n < 2;
        unitBox.querySelectorAll('[data-ps-unit]').forEach(function (row) {
          var on = parseInt(row.getAttribute('data-ps-unit'), 10) <= n;
          row.hidden = !on;
          row.querySelectorAll('input').forEach(function (i) { i.disabled = !on; });
        });
        var lbl = root.querySelector('[data-ps-coloropt] [data-ps-optlabel]');
        if (lbl) lbl.textContent = n >= 2 ? unitBox.getAttribute('data-label-first') : lbl.getAttribute('data-default');
      }
      if (unitBox) {
        unitBox.querySelectorAll('input').forEach(function (i) {
          i.addEventListener('change', function () {
            var v = i.closest('[data-ps-unit]').querySelector('[data-ps-unit-value]');
            if (v) v.textContent = i.value;
          });
        });
        root.querySelectorAll('.ps-bundle input').forEach(function (i) { i.addEventListener('change', syncUnits); });
        syncUnits();
      }

      var qty = root.querySelector('.ps-qty input');
      root.querySelectorAll('[data-ps-qty]').forEach(function (b) {
        b.addEventListener('click', function () {
          var n = parseInt(qty.value, 10) || 1;
          n += parseInt(b.getAttribute('data-ps-qty'), 10);
          qty.value = Math.max(1, n);
        });
      });

      var form = root.querySelector('form[action*="/cart/add"]');
      var msg = root.querySelector('.ps-msg');
      if (form) {
        form.addEventListener('submit', function (ev) {
          var drawer = document.querySelector('cart-drawer');
          ev.preventDefault();
          if (btn) btn.disabled = true;
          var fd = new FormData(form);
          if (drawer && drawer.getSectionsToRender) {
            fd.append('sections', drawer.getSectionsToRender().map(function (s) { return s.id; }));
            fd.append('sections_url', window.location.pathname);
          }
          fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
            method: 'POST', body: fd, headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }
          }).then(function (r) { return r.json(); }).then(function (res) {
            if (btn) btn.disabled = false;
            if (res.status) { if (msg) msg.textContent = res.description || res.message; return; }
            if (drawer && drawer.renderContents) {
              drawer.classList.remove('is-empty');
              drawer.renderContents(res);
            } else {
              window.location.href = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart';
            }
          }).catch(function () { form.submit(); });
        });
      }

      // barra fija de compra en móvil
      var sticky = document.querySelector('.ps-sticky-buy');
      if (sticky && btn && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (en) {
          en.forEach(function (e) { sticky.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0); });
        });
        io.observe(btn);
        var sb = sticky.querySelector('button');
        if (sb) sb.addEventListener('click', function () { btn.scrollIntoView({ behavior: 'smooth', block: 'center' }); });
      }
    });
  }

  // Carrusel de reseñas reales (Judge.me) bajo el botón de compra
  function initReviewSlider() {
    document.querySelectorAll('[data-ps-revslider]').forEach(function (box) {
      if (box.dataset.psReady) return;
      var pid = box.getAttribute('data-pid');
      var tries = 0;
      function esc(s) { var d = document.createElement('div'); d.textContent = s || ''; return d.innerHTML; }
      function build() {
        var w = window.jdgm && jdgm.data && jdgm.data.reviewWidget && jdgm.data.reviewWidget[pid];
        if (!w) { if (++tries < 20) setTimeout(build, 500); return; }
        box.dataset.psReady = '1';
        var max = parseInt(box.getAttribute('data-max'), 10) || 6;
        var list = (w.reviews || []).filter(function (r) { return r.rating >= 4 && r.body && r.body.trim(); }).slice(0, max);
        if (!list.length) return;
        var track = box.querySelector('[data-ps-revtrack]');
        var dots = box.querySelector('[data-ps-revdots]');
        var star = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m12 2 3.1 6.3 6.9 1-5 4.9 1.2 6.8L12 17.8 5.8 21l1.2-6.8-5-4.9 6.9-1z"/></svg>';
        track.innerHTML = list.map(function (r) {
          var pic = (r.pictures_urls && r.pictures_urls[0]) ? (r.pictures_urls[0].compact || r.pictures_urls[0].small || r.pictures_urls[0].original || r.pictures_urls[0]) : '';
          if (typeof pic !== 'string') pic = '';
          var avatar = pic ? '<img class="ps-rev__avatar" src="' + esc(pic) + '" alt="" loading="lazy">' : '<span class="ps-rev__avatar ps-rev__avatar--init">' + esc(r.reviewer_initial || (r.reviewer_name || '?').charAt(0)) + '</span>';
          var body = r.body.trim(); if (body.length > 170) body = body.slice(0, 167).trim() + '…';
          var stars = ''; for (var i = 0; i < 5; i++) stars += '<i class="' + (i < r.rating ? 'on' : '') + '">' + star + '</i>';
          return '<figure class="ps-rev">' + avatar + '<div class="ps-rev__body"><blockquote>' + esc(body) + '</blockquote><figcaption><span class="ps-rev__name">' + esc(r.reviewer_name || 'Cliente') + '</span><span class="ps-rev__stars" aria-label="' + r.rating + ' de 5">' + stars + '</span></figcaption></div></figure>';
        }).join('');
        dots.innerHTML = list.length > 1 ? list.map(function (_, i) { return '<button type="button" aria-label="Reseña ' + (i + 1) + '"' + (i === 0 ? ' class="is-on"' : '') + '></button>'; }).join('') : '';
        box.hidden = false;
        var idx = 0, n = list.length, timer;
        function go(i) {
          idx = (i + n) % n;
          track.scrollTo({ left: track.clientWidth * idx, behavior: reduce ? 'auto' : 'smooth' });
        }
        function mark() {
          var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
          idx = i;
          dots.querySelectorAll('button').forEach(function (b, k) { b.classList.toggle('is-on', k === i); });
        }
        track.addEventListener('scroll', function () { window.requestAnimationFrame(mark); }, { passive: true });
        dots.querySelectorAll('button').forEach(function (b, k) { b.addEventListener('click', function () { go(k); restart(); }); });
        function restart() {
          clearInterval(timer);
          if (n > 1 && !reduce) timer = setInterval(function () { go(idx + 1); }, (parseInt(box.getAttribute('data-interval'), 10) || 5) * 1000);
        }
        box.addEventListener('pointerdown', function () { clearInterval(timer); });
        box.addEventListener('pointerup', restart);
        restart();
      }
      build();
    });
  }

  // Temporizador con hora de fin real (igual para todos los visitantes)
  function initCountdown() {
    document.querySelectorAll('[data-ps-countdown]').forEach(function (el) {
      if (el.dataset.psReady) return;
      el.dataset.psReady = '1';
      // Colocar la franja arriba del todo (encima de la cabecera), fuera del editor de Shopify
      if (!window.Shopify || !Shopify.designMode) {
        var top = document.querySelector('.ps-countdown-top-slot');
        if (!top) { top = document.createElement('div'); top.className = 'ps-countdown-top-slot'; document.body.insertBefore(top, document.body.firstElementChild); }
        el.classList.add('ps-countdown--top');
        top.appendChild(el);
        // Altura de la franja, para que la cabecera fija quede justo debajo
        var setH = function () { document.documentElement.style.setProperty('--ps-cd-h', top.offsetHeight + 'px'); };
        window.addEventListener('resize', setH);
        setTimeout(setH, 0);
      }
      var end = Date.parse(el.getAttribute('data-end'));
      if (isNaN(end)) return;
      var h = el.querySelector('[data-ps-h]'), m = el.querySelector('[data-ps-m]'), s = el.querySelector('[data-ps-s]');
      function pad(n) { return (n < 10 ? '0' : '') + n; }
      function tick() {
        var left = Math.floor((end - Date.now()) / 1000);
        if (left <= 0) { el.hidden = true; clearInterval(t); return; }
        el.hidden = false;
        h.textContent = pad(Math.floor(left / 3600));
        m.textContent = pad(Math.floor((left % 3600) / 60));
        s.textContent = pad(left % 60);
      }
      var t = setInterval(tick, 1000);
      tick();
    });
  }

  function initAll() {
    initCountdown();
    initReviewSlider();
    initReveal();
    initCountUp();
    initParallax();
    initColors();
    initProduct();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
